export default "__VITE_ASSET__644e3627__"